export class CommunityListConfig {
  type: string = "AllCommunitiesLatestFeed";
  filters: {
    term?: string;
    tag?: string;
    foundedBy?: string;
    sortBy?: string;
    limit?: number;
    offset?: number;
  } = {};
}
